export default __webpack_public_path__ + "images/681a5d1bc89c8f34308ef3698c84ad8d-Eventbrite_NYE_HomepageB_1067x312.webp";